import {
  CircularProgress as MuiCircularProgress,
  type CircularProgressProps as MuiCircularProgressProps
} from '@mui/material';

export type SpinnerProps = MuiCircularProgressProps;

export const Spinner = (props: Readonly<SpinnerProps>) => <MuiCircularProgress {...props} />;
